import "./Events.scss";
import PageLayout from "../../layouts/pagelayout/PageLayout";
import { Fragment, useState, useEffect } from "react";
import EventCard from "./eventCard/EventCard";
import WOW from "wow.js";
import axios from "axios";
import { baseUrl, getEventCategory, getEvents } from "../../utils/apiData";
import LoaderCard from "../../components/loaderCard/LoaderCard";
import Pagination from "@mui/material/Pagination";

const Events = () => {
  const itemsPerPage = 5;
  const [page, setPage] = useState(1);
  const [tab, setTab] = useState("");
  const [category, setCategory] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [eventLoader, setEventLoader] = useState(false);

  // Get Events Categorie
  const getEventCategoriesApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getEventCategory}`);
      if (res?.data?.success) {
        setCategory(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  // Get Events By CategoryId

  const getEventsApi = async () => {
    setEventLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${getEvents}`, {
        categoryId: tab,
      });
      if (res?.data?.success) {
        setEventList(res?.data?.data);
        setEventLoader(false);
      }
    } catch (error) {
      setEventLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getEventCategoriesApi();
    getEventsApi();
    const wow = new WOW();
    wow.init();
  }, []);

  useEffect(() => {
    getEventsApi();
  }, [tab]);

  const pageChange = (e, value) => {
    setPage(value);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <PageLayout>
      {loader || eventLoader ? (
        <LoaderCard />
      ) : (
        <section className="events_page">
          <div className="content_wrap p_bottom">
            <h2 className="wow fadeInUp">Events</h2>
            <div className="tab_wrap">
              <button
                type="button"
                className={`${tab === "" ? "active" : ""} wow fadeInUp`}
                onClick={() => setTab("")}
              >
                All
              </button>
              {category?.length > 0 ? (
                category?.map((data, j) => {
                  return (
                    <button
                      type="button"
                      key={data?._id}
                      className={`${
                        tab === data?._id ? "active" : ""
                      } wow fadeInUp`}
                      onClick={() => setTab(data?._id)}
                      data-wow-delay={`${j * 0.1}s`}
                    >
                      {data?.category_name || "-"}
                    </button>
                  );
                })
              ) : (
                <p className="text-center">Category not found...</p>
              )}
            </div>

            <div className="cvents_sec">
              {eventList?.length > 0 ? (
                eventList
                  ?.slice(
                    page * itemsPerPage - itemsPerPage,
                    page * itemsPerPage
                  )
                  ?.map((data) => {
                    return (
                      <Fragment key={data?._id}>
                        <EventCard data={data} />
                      </Fragment>
                    );
                  })
              ) : (
                <p className="text-center">Event not found...</p>
              )}
            </div>

            {/* Pagination */}
            <div className="pagination_sec wow fadeInUp">
              <Pagination
                count={Math.ceil(eventList.length / itemsPerPage)}
                // page={page}
                onChange={pageChange}
                shape="rounded"
              />
            </div>
          </div>
        </section>
      )}
    </PageLayout>
  );
};

export default Events;
